import React, { useState } from "react";
import { format } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CustomDatePicker: React.FC<{
  checkInDate: Date | null;
  setCheckInDate: (date: Date | null) => void;
  checkOutDate: Date | null;
  setCheckOutDate: (date: Date | null) => void;
}> = ({ checkInDate, setCheckInDate, checkOutDate, setCheckOutDate }) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    checkInDate,
    checkOutDate,
  ]);
  const [startDate, endDate] = dateRange;

  return (
    <>
      <style>{`
        .date-input {
          width: 100%;
          height: 44px;
          padding: 8px 12px;
          border-radius: 99px;
          border: 1px solid #ccc;
          font-size: 14px;
          cursor: pointer;
        }

        .date-input::placeholder {
          font-size: 13px;
          color: #7E7E7E;
        }

        .calendar-wrapper {
          position: absolute;
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 8px;
          padding: 12px;
          margin-top: 8px;
          z-index: 50;
        }

        @media (max-width: 768px) {
          .date-input {
            font-size: 13px;
          }

          .date-input::placeholder {
            font-size: 10px;
          }

          .calendar-wrapper {
            position: fixed;
            bottom: 1rem;
            left: 0;
            right: 0;
            width: 95vw;
            max-width: 95vw;
            margin: auto;
            border-radius: 16px 16px 0 0;
            padding: 10px;
          }

          .react-datepicker {
            width: 100%;
          }

          .react-datepicker__month-container {
            width: 100%;
          }
        }
      `}</style>

      <div className="position-relative w-100 mx-auto">
        <input
          type="text"
          placeholder="Check-in - Check-out"
          value={
            startDate && endDate
              ? `${format(startDate, "yyyy-MM-dd")} - ${format(
                  endDate,
                  "yyyy-MM-dd",
                )}`
              : ""
          }
          onClick={() => setShowCalendar(true)}
          readOnly
          className="date-input"
        />

        {showCalendar && (
          <div className="calendar-wrapper">
            <DatePicker
              selected={startDate}
              onChange={(update) => {
                const [newCheckIn, newCheckOut] = update as [
                  Date | null,
                  Date | null,
                ];
                setDateRange([newCheckIn, newCheckOut]);
                setCheckInDate(newCheckIn);
                setCheckOutDate(newCheckOut);
                if (newCheckOut) setShowCalendar(false);
              }}
              startDate={startDate}
              endDate={endDate}
              selectsRange
              inline
            />

            <button
              className="mt-3 btn btn-search rounded-pill w-100"
              onClick={() => setShowCalendar(false)}
            >
              Close
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default CustomDatePicker;
